import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import { ThemeProvider } from './context/ThemeProvider'
import App from './App'
import { legacyToastRenderer } from './components/Toast'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 1000 * 60 * 5, retry: 1 } },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <App />
        {/* Toaster renders all variants through legacyToastRenderer so existing
            toast.success / toast.error call sites pick up the themed surface
            (card-matching radius, dark-mode aware, brand-tinted accent stripe)
            without needing to migrate each one. New code should prefer
            `notify.*` from components/Toast.tsx for description + action support. */}
        <Toaster
          position="top-right"
          gutter={10}
          toastOptions={{
            duration: 4000,
            // Reset library defaults so ThemedToast's own surface is what you see.
            style: { background: 'transparent', boxShadow: 'none', padding: 0, margin: 0, maxWidth: 'none' },
            ariaProps: { role: 'status', 'aria-live': 'polite' },
          }}>
          {(t) => legacyToastRenderer(t)}
        </Toaster>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
